export default __webpack_public_path__ + "static/media/Tuners Craft.5f534237.png";